import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useContext } from 'react';
export var initialState = {
  map: undefined,
  BMap: undefined,
  container: undefined
};
export var reducer = function reducer(state, action) {
  return _extends({}, state, action);
};
export var Context = /*#__PURE__*/React.createContext({
  state: initialState,
  dispatch: function dispatch() {
    return null;
  }
});
export function useMapContext() {
  var _useContext = useContext(Context),
    state = _useContext.state,
    dispatch = _useContext.dispatch;
  return _extends({}, state, {
    state: state,
    dispatch: dispatch
  });
}